import type { ModuleDef } from '@britania/teams-kit-react';
import {
  PeopleCheckmarkRegular,
  TaskListLtrRegular,
} from '@fluentui/react-icons';

export const approvalsModule: ModuleDef = {
  path: 'aprovacoes',
  title: 'Aprovações',
  icon: PeopleCheckmarkRegular,
  placement: 'main',
  pages: [
    {
      path: 'destinatarios',
      title: 'Destinatários dos lembretes',
      description: 'Veja quem recebe os lembretes e os cards de cada pessoa.',
      icon: PeopleCheckmarkRegular,
      permission: 'Routines.Read',
      load: () =>
        import('#src/modules/approvals/RecipientsPage').then(
          (m) => m.RecipientsPage,
        ),
    },
    {
      path: 'pendentes',
      title: 'Chamados pendentes',
      description: 'Chamados do Softdesk que aguardam aprovação.',
      icon: TaskListLtrRegular,
      permission: 'Tickets.Read',
      load: () =>
        import('#src/modules/approvals/PendingTicketsPage').then(
          (m) => m.PendingTicketsPage,
        ),
    },
  ],
};
